module.exports = __webpack_public_path__ + "img/Echolot-Pavillon-3.60f69df9.jpg";